import React from "react";
import Home from "./pages/Home";
import "./App.css";
import { DonationProvider } from "./Components/DonationContext";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { APP_BASE_PATH } from "./utils/paths";
import AboutVikash from "./About/About-vikash";
import ContactUs from "./pages/Contact-Us";
import VisionMission from "./About/Vision&Mission";
import OurPartners from "./About/OurPartners";
import OurTeam from "./About/OurTeam";
import Leprosy from "./Actions/Leprosy";
import Leprosy1 from "./Actions/Leprosy1";
import EnsureEducation from "./Actions/EnsureEducation";
import SustainableLivelihoods from "./Programs/SustainableLivelihoods";
import Health from "./Programs/Health";
import QualityEducation from "./Programs/QualityEducation";
import GoodGovernance from "./Programs/GoodGovernance";
import OpportunitiesForTheDisabled from "./Programs/OpportunitiesForTheDisabled";
import GoodHabitat from "./Programs/GoodHabitat";
import Blog from "./pages/Blog";
import News from "./Media/News";
import Photogallery from "./Media/PhotoGallery";
import VideoGallery from "./Media/VideoGallery";
import ResearchPublications from "./Resources/ResearchPublications";
import CaseStudies from "./Resources/CaseStudies";
import AnnualReports from "./Resources/AnnualReports";
import EventsReports from "./Resources/EventsReports";
import Volunteers from "./JoinUs/Volunteers";
import Interns from "./JoinUs/Interns";
import Career from "./JoinUs/Career";
import AgricultureLivelihood from "./Programs/AgricultureLivelihood";
import NonFarmBasedLivelihood from "./Programs/NonFarmBasedLivelihood";
import NonFormalEducation from "./Programs/NonFormalEducation";
import CrecheProgram from "./Programs/CrecheProgram";
import ChildLabourPrevention from "./Programs/ChildLabourPrevention";
import CaringForTribalChildren from "./Programs/CaringForTribalChildren";
import InclusiveEducation from "./Programs/InclusiveEducation";
import ChildrenParliament from "./Programs/ChildrenParliament";
import AdvocacyNetworking from "./Programs/AdvocacyNetworking";
import SpecialCenters from "./Programs/SpecialCenters";
import RuralGovernance from "./Programs/RuralGovernance";
import UrbanGovernance from "./Programs/UrbanGovernance";
import Health1 from "./Programs/Health1";
import EducationAndBehaviorDevelopment from "./Programs/EducationAndBehaviorDevelopment";
import EconomicDevelopment from "./Programs/EconomicDevelopment";
import SocialDevelopment from "./Programs/SocialDevelopment";
import Housing from "./Programs/Housing";
import Forestry from "./Programs/Forestry";
import RenewableEnergy from "./Programs/RenewableEnergy";
import Water from "./Programs/Water";
import Sanitation from "./Programs/Sanitation";
import SolidWasteManagement from "./Programs/SolidWasteManagement";
import BioMedicalWasteManagement from "./Programs/BioMedicalWasteManagement";
import FaqSection from "./pages/FaqSection";
import Newssyle from "./Media/Newssyle";
import Rehabilation from "./Blog/Rehabilation";
import IR from "./Blog/IR";
import Intervention from "./Blog/Intervention";
import Empowering from "./Blog/Empowering";
import ANewHopeforDisabledChildren from "./Blog/ANewHopeforDisabledChildren";
import Crowfunding from "./Blog/Crowfunding";
import Truthsmyth from "./Blog/TruthsMyth";
import GuptaOvercomingChallengeswithVikashFoundationSupport from "./Blog/GuptaOvercomingChallengeswithVikashFoundationSupport";
import RedefiningDisabilityCanyoudoitBecausewedid from "./Blog/RedefiningDisabilityCanyoudoitBecausewedid";
import SumitaOvercomingObstacles from "./Blog/SumitaOvercomingObstacles";
import AniketaHeartfeltJourneyVikashFoundation from "./Blog/AniketaHeartfeltJourneyVikashFoundation";
import ProtectedRoute from "./Components/ProtectedRoute";
import AdminLogin from "./Admin/Login";
import AdminLayout from "./Admin/Layout";
import AdminDashboard from "./Admin/Dashboard";
import CareersAdd from "./Admin/CareersAdd";
import CareersList from "./Admin/CareersList";
import CareerApplicants from "./Admin/CareerApplicants";
import InternshipsAdd from "./Admin/InternshipsAdd";
import InternshipsList from "./Admin/InternshipsList";
import InternshipApplicants from "./Admin/InternshipApplicants";
import BlogsAdd from "./Admin/BlogsAdd";
import BlogsList from "./Admin/BlogsList";
import EventsAdd from "./Admin/EventsAdd";
import EventsList from "./Admin/EventsList";
import GalleryAdd from "./Admin/GalleryAdd";
import GalleryList from "./Admin/GalleryList";
import ReportsAdd from "./Admin/ReportsAdd";
import ReportsList from "./Admin/ReportsList";
import SeoManagement from "./Admin/SeoManagement";
import ApplicantsList from "./Admin/ApplicantsList";
import BankDetailsAdd from "./Admin/BankDetailsAdd";
import BankDetailsList from "./Admin/BankDetailsList";
import DonationsList from "./Admin/DonationsList";
import ContactMessagesList from "./Admin/ContactMessagesList";
import BlogDetail from "./pages/BlogDetail";
import JobDetail from "./JoinUs/JobDetail";
import SeoRouteHandler from "./Components/SeoRouteHandler";

function App() {
  const basename = process.env.PUBLIC_URL || APP_BASE_PATH || '';
  return (
    <div className="">
      <Router basename={basename}>
        <DonationProvider>
          <SeoRouteHandler />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-vikash" element={<AboutVikash />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/vision-mission" element={<VisionMission />} />
            <Route path="/our-partners" element={<OurPartners />} />
            <Route
              path="/sustainable-livelihoods"
              element={<SustainableLivelihoods />}
            />
            <Route
              path="/agriculture-livelihood"
              element={<AgricultureLivelihood />}
            />
            <Route
              path="/non-farm-based-livelihood"
              element={<NonFarmBasedLivelihood />}
            />
            <Route path="/health" element={<Health />} />
            <Route path="" element={<FaqSection />} />
            <Route path="/leprosy" element={<Leprosy />} />
            <Route path="/leprosy1" element={<Leprosy1 />} />
            <Route path="/ens" element={<EnsureEducation />} />

            <Route path="/quality-education" element={<QualityEducation />} />
            <Route
              path="/non-formal-education"
              element={<NonFormalEducation />}
            />
            <Route path="/creche-program" element={<CrecheProgram />} />
            <Route
              path="/child-labour-prevention"
              element={<ChildLabourPrevention />}
            />
            <Route
              path="/caring-for-tribal-children"
              element={<CaringForTribalChildren />}
            />
            <Route
              path="/inclusive-education"
              element={<InclusiveEducation />}
            />
            <Route
              path="/children-parliament"
              element={<ChildrenParliament />}
            />
            <Route
              path="/advocacy-networking"
              element={<AdvocacyNetworking />}
            />
            <Route path="/special-centers" element={<SpecialCenters />} />
            <Route path="/rural-governance" element={<RuralGovernance />} />
            <Route path="/urban-governance" element={<UrbanGovernance />} />
            <Route path="/health1" element={<Health1 />} />
            <Route
              path="/education-and-behavior-development"
              element={<EducationAndBehaviorDevelopment />}
            />
            <Route
              path="/economic-development"
              element={<EconomicDevelopment />}
            />
            <Route path="/social-development" element={<SocialDevelopment />} />
            <Route path="/housing" element={<Housing />} />
            <Route path="/forestry" element={<Forestry />} />
            <Route path="/renewable-energy" element={<RenewableEnergy />} />
            <Route path="/water" element={<Water />} />
            <Route path="/sanitation" element={<Sanitation />} />
            <Route
              path="/solid-waste-management"
              element={<SolidWasteManagement />}
            />
            <Route
              path="/bio-medical-waste-management"
              element={<BioMedicalWasteManagement />}
            />
            <Route path="/good-governance" element={<GoodGovernance />} />
            <Route
              path="/opportunities-for-the-disabled"
              element={<OpportunitiesForTheDisabled />}
            />
            <Route path="/good-habitat" element={<GoodHabitat />} />
            <Route path="/our-team" element={<OurTeam />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/news" element={<News />} />
            <Route path="/photo-gallery" element={<Photogallery />} />
            <Route path="/video-gallery" element={<VideoGallery />} />
            <Route
              path="/research-publications"
              element={<ResearchPublications />}
            />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/annual-reports" element={<AnnualReports />} />
            <Route path="/events-reports" element={<EventsReports />} />
            <Route path="/volunteer" element={<Volunteers />} />
            <Route path="/interns" element={<Interns />} />
            <Route path="/career" element={<Career />} />
            <Route path="/job/:id" element={<JobDetail />} />
            <Route path="" element={<Newssyle />} />
            <Route
              path="/A-New-Hope-for-Disabled-Children"
              element={<ANewHopeforDisabledChildren />}
            />
            <Route
              path="/Redefining-Disability-Can-you-do-it-Because-we-did"
              element={<RedefiningDisabilityCanyoudoitBecausewedid />}
            />
            <Route
              path="/Sumita-Overcoming-Obstacles"
              element={<SumitaOvercomingObstacles />}
            />
            <Route
              path="/Gupta-Overcoming-Challenges-with-Vikash-Foundation-Support"
              element={<GuptaOvercomingChallengeswithVikashFoundationSupport />}
            />
            <Route
              path="/Aniketa-Heartfelt-Journey-Vikash-Foundation"
              element={<AniketaHeartfeltJourneyVikashFoundation />}
            />
            <Route path="/emp" element={<Empowering />} />
            <Route path="/crowfunding" element={<Crowfunding />} />
            <Route path="/truth-myth" element={<Truthsmyth />} />
            <Route path="/rehab" element={<Rehabilation />} />
            <Route path="/inclusive-rehab-services" element={<IR />} />
            <Route path="/tyi" element={<Intervention />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="careers" element={<CareersList />} />
                <Route path="careers/add" element={<CareersAdd />} />
                <Route path="career-applicants" element={<CareerApplicants />} />
                <Route path="internships" element={<InternshipsList />} />
                <Route path="internships/add" element={<InternshipsAdd />} />
                <Route path="internship-applicants" element={<InternshipApplicants />} />
                <Route path="blogs" element={<BlogsList />} />
                <Route path="blogs/add" element={<BlogsAdd />} />
                <Route path="events" element={<EventsList />} />
                <Route path="events/add" element={<EventsAdd />} />
                <Route path="gallery" element={<GalleryList />} />
                <Route path="gallery/add" element={<GalleryAdd />} />
                <Route path="reports" element={<ReportsList />} />
                <Route path="reports/:type" element={<ReportsList />} />
                <Route path="reports/add" element={<ReportsAdd />} />
                <Route path="reports/edit" element={<ReportsAdd />} />
                <Route path="seo" element={<SeoManagement />} />
                <Route path="applicants" element={<ApplicantsList />} />
                <Route path="bank-details" element={<BankDetailsList />} />
                <Route path="bank-details/add" element={<BankDetailsAdd />} />
                <Route path="donations" element={<DonationsList />} />
                <Route path="contact-messages" element={<ContactMessagesList />} />
              </Route>
            </Route>
            
          </Routes>
        </DonationProvider>
      </Router>
    </div>
  );
}

export default App;
